import React from "react";

import { FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";

import { State } from "./CreateReportSection";

interface Props {
  data: State["pickFiltersSet"];
  setData: (cb: (prevState: State["pickFiltersSet"]) => State["pickFiltersSet"]) => void;
}

export const PickParametersSet: React.FC<Props> = ({ data, setData }) => {
  return (
    <Stack sx={{ minWidth: 450 }}>
      <RadioGroup
        value={data.isUseCurrent}
        onChange={(e) => setData((prev) => ({ ...prev, isUseCurrent: e.target.value === "true" }))}
      >
        <FormControlLabel value={true} control={<Radio />} label="Use Current Parameter Set" />
        <FormControlLabel value={false} control={<Radio />} label="Create New Parameter Set" />
      </RadioGroup>
    </Stack>
  );
};
